import { Link as MuiLink, LinkProps as MuiLinkProps } from "@bvhi/ui-base";
import { Link, LinkProps } from "@tanstack/react-router";

export type Props = LinkProps & MuiLinkProps;

export const RouterLink = ({ ...props }: Props) => {
  return <MuiLink {...props} component={Link} />;
};
